import { Link } from "react-router-dom";
import { MapPin, Sparkles, Users } from "lucide-react";
import { mediaUrl, money, typeLabel } from "../api/client";

export default function VenueCard({ venue }) {
  return (
    <Link
      to={`/u/${venue.slug}`}
      className="group card overflow-hidden transition duration-300 hover:-translate-y-1 hover:shadow-glow"
    >
      <div className="relative h-56 overflow-hidden">
        {venue.coverImage ? (
          <img
            src={mediaUrl(venue.coverImage)}
            alt={venue.name}
            className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
          />
        ) : (
          <div className="h-full w-full bg-blush" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-ink/10 to-transparent" />
        <span className="chip absolute left-4 top-4 bg-white/90 text-plum">
          {typeLabel(venue.type)}
        </span>
        <span className="chip absolute right-4 top-4 bg-gold text-ink">
          ★ {venue.rating}
        </span>
        <div className="absolute bottom-4 left-4 right-4 text-cream">
          <p className="flex items-center gap-1 text-xs text-cream/80">
            <MapPin size={12} /> {venue.city}
          </p>
          <h3 className="font-serif text-2xl leading-tight">{venue.name}</h3>
        </div>
      </div>
      <div className="space-y-3 p-5">
        <p className="line-clamp-2 text-sm text-ink/65">{venue.tagline}</p>
        <div className="flex items-center justify-between text-sm">
          <span className="inline-flex items-center gap-1 text-ink/60">
            <Users size={14} /> {venue.capacity} guests
          </span>
          <span className="inline-flex items-center gap-1 font-semibold text-rose">
            <Sparkles size={14} /> from {money(venue.startingPrice, venue.currency)}
          </span>
        </div>
      </div>
    </Link>
  );
}
